import Service from '@/services/modules/link_customers_to_contracts';

const Import = async({ commit }, _object) => {
    const response = Service.add(_object);

    response.then(function (_response) {
        commit('add', _response);
    });

    return response;
};

export default {
    Import
};